import { render, staticRenderFns } from "./newAddOrder.vue?vue&type=template&id=33d5d034&scoped=true"
import script from "./newAddOrder.vue?vue&type=script&lang=js"
export * from "./newAddOrder.vue?vue&type=script&lang=js"
import style0 from "./newAddOrder.vue?vue&type=style&index=0&id=33d5d034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d5d034",
  null
  
)

export default component.exports